import {
  PrimaryRegularButton,
  SecondaryRegularButton
} from 'components/ReusableComponents/Button/RegularButtons'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useEmailEditor } from 'features/EmailEditor/EmailEditorContext'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'

import styles from './EmailEditor.module.scss'

const TestEmail = () => {
  const { currentUser, sendTestEmail } = useEmailEditor()

  const { addToast } = useToasts()

  const [emailToSend, setEmailToSend] = useState(currentUser.email)

  const handleSendTestEmail = () => {
    setTimeout(() => {
      sendTestEmail(emailToSend)
        .then(() => {
          addToast('Test email sent successfully!', { appearance: 'success' })
        })
        .catch(() => {
          addToast('Failed to send test email.', { appearance: 'error' })
        })
    }, 500)
  }

  return (
    <div className={styles.emailTestHolder}>
      <p className={styles.emailTestTitle}>Test your email</p>
      <div className={styles.emailTestForm}>
        <TextInput
          type="email"
          value={emailToSend}
          onChangeValue={value => setEmailToSend(value)}
        />
        <SecondaryRegularButton onClick={handleSendTestEmail}>
          Send Test Email
        </SecondaryRegularButton>
      </div>
    </div>
  )
}

export default TestEmail
